import { Mail, Youtube, Instagram, Facebook, Music2, ArrowUpRight } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { useLang } from "@/i18n/LanguageContext";
import ContactForm from "@/components/site/ContactForm";
import { Reveal, SectionHead } from "@/components/site/Reveal";

const ContattiPage = () => {
  const { t } = useLang();
  useSeo("contatti");

  return (
    <div data-testid="contatti-page">
      <section className="pt-40 pb-20 lg:pt-48 lg:pb-24 bg-[#EFECE6]" data-testid="contatti-hero">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="h-px w-12 bg-[#C5A059]" />
              <span className="text-[11px] tracking-[0.3em] uppercase font-medium text-[#C5A059]">{t("contatti.eyebrow")}</span>
            </div>
          </Reveal>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-8 leading-[1.08]">
            <Reveal delay={0.1}>{t("contatti.titleA")}</Reveal>
            <Reveal delay={0.2}><span className="italic text-[#9E7B36]">{t("contatti.titleB")}</span></Reveal>
          </h1>
        </div>
      </section>

      <section className="py-20 lg:py-28" data-testid="contatti-body">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-4 space-y-10">
            <div>
              <h2 className="text-[11px] tracking-[0.25em] uppercase text-[#C5A059] font-medium mb-5">{t("contatti.emailLabel")}</h2>
              <a href="mailto:monferratoimmersive@gmail.com" data-testid="contatti-email" className="inline-flex items-center gap-3 text-base text-[#1C1B18] hover:text-[#9E7B36] transition-colors">
                <Mail size={16} className="text-[#C5A059]" /> monferratoimmersive@gmail.com
              </a>
            </div>
            <div>
              <h2 className="text-[11px] tracking-[0.25em] uppercase text-[#C5A059] font-medium mb-5">{t("contatti.channelsLabel")}</h2>
              <ul className="space-y-4 text-sm">
                <li><a href="https://www.youtube.com/@MonferratoImmersive" target="_blank" rel="noopener noreferrer" data-testid="contatti-youtube" className="inline-flex items-center gap-3 hover:text-[#9E7B36] transition-colors"><Youtube size={16} className="text-[#C5A059]" /> YouTube <ArrowUpRight size={12} /></a></li>
                <li><a href="https://www.instagram.com/monferratoimmersive" target="_blank" rel="noopener noreferrer" data-testid="contatti-instagram" className="inline-flex items-center gap-3 hover:text-[#9E7B36] transition-colors"><Instagram size={16} className="text-[#C5A059]" /> Instagram <ArrowUpRight size={12} /></a></li>
                <li><a href="https://www.facebook.com/monferratoimmersive" target="_blank" rel="noopener noreferrer" data-testid="contatti-facebook" className="inline-flex items-center gap-3 hover:text-[#9E7B36] transition-colors"><Facebook size={16} className="text-[#C5A059]" /> Facebook <ArrowUpRight size={12} /></a></li>
              </ul>
            </div>
            <div>
              <h2 className="text-[11px] tracking-[0.25em] uppercase text-[#C5A059] font-medium mb-5 flex items-center gap-2"><Music2 size={13} /> Echoes From Above</h2>
              <ul className="space-y-4 text-sm">
                <li><a href="https://open.spotify.com/intl-it/artist/7ngeIzyK6qFXTxEo9UXSg9?si=NCt0BhrfTCefzGImsHEhpQ" target="_blank" rel="noopener noreferrer" data-testid="contatti-spotify" className="inline-flex items-center gap-3 hover:text-[#9E7B36] transition-colors">Spotify <ArrowUpRight size={12} /></a></li>
                <li><a href="https://music.apple.com/it/artist/echoes-from-above/1894971984" target="_blank" rel="noopener noreferrer" data-testid="contatti-apple-music" className="inline-flex items-center gap-3 hover:text-[#9E7B36] transition-colors">Apple Music <ArrowUpRight size={12} /></a></li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8">
            <SectionHead eyebrow={t("contatti.formEyebrow")} title={t("contatti.formTitle")} />
            <div className="mt-10">
              <Reveal delay={0.15}>
                <ContactForm source="contatti" />
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContattiPage;
